"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.a11ySelectRules = exports.withStaticProps = exports.defaultFilterOption = exports.getOptionStringContent = exports.addChildrenA11yAttributes = exports.addOptionsPropA11yAttributes = void 0;
const react_1 = require("react");
const helpers_1 = require("../helpers");
const Select_1 = require("./Select");
const isOptionGroup = (optionOrGroup) => {
    return "options" in optionOrGroup;
};
// Screen readers fail to calculate the number of items and the index of the current item in Antd's select
// which breaks the accessibility of the component
// We can override the automatic calculation by providing the total number of items with "aria-setsize" and
// every item's position in the list with "aria-posinset"
/** Adds aria-attributes to options passed through the `options` prop */
const addOptionsPropA11yAttributes = (options) => {
    const optionsCount = options.reduce((acc, obj) => acc + (isOptionGroup(obj) ? obj.options.length : 1), 0);
    let currentOptionPosition = 1;
    const addA11y = (opt) => (Object.assign(Object.assign({}, opt), { "aria-setsize": optionsCount, "aria-posinset": currentOptionPosition++, "aria-label": (0, exports.getOptionStringContent)(opt.label) }));
    return options.map((obj) => (isOptionGroup(obj) ? Object.assign(Object.assign({}, obj), { options: obj.options.map(addA11y) }) : addA11y(obj)));
};
exports.addOptionsPropA11yAttributes = addOptionsPropA11yAttributes;
/** Adds aria-attributes to options passed as children using the `Option` component */
const addChildrenA11yAttributes = (children) => {
    let optionsCount = 0;
    let currentOptionPosition = 1;
    // Iterate over all options a first time to count the number of options
    (0, helpers_1.deepMapChildren)(children, (el) => {
        if ((0, react_1.isValidElement)(el) && el.type === Select_1.OptionType)
            optionsCount++;
    });
    // Map over all options a second time to add attributes
    return (0, helpers_1.deepMapChildren)(children, (el) => {
        if (!(0, react_1.isValidElement)(el) || el.type !== Select_1.OptionType)
            return el;
        return (0, react_1.cloneElement)(Object.assign(Object.assign({}, el), { key: el.props.value }), {
            "aria-setsize": optionsCount,
            "aria-posinset": currentOptionPosition++,
            "aria-label": (0, exports.getOptionStringContent)(el),
        });
    });
};
exports.addChildrenA11yAttributes = addChildrenA11yAttributes;
/** Recursively iterates on children and extracts the string contents */
const getOptionStringContent = (option) => {
    const strings = [];
    (0, helpers_1.deepMapChildren)(option, (el) => {
        if (typeof el === "string" || typeof el === "number")
            strings.push(el);
    });
    return strings.join(" ");
};
exports.getOptionStringContent = getOptionStringContent;
/** Default function for filtering select options when `showSearch` prop is true */
const defaultFilterOption = (input, option) => {
    var _a, _b, _c, _d;
    const optValue = (_d = (_b = (_a = option) === null || _a === void 0 ? void 0 : _a.label) !== null && _b !== void 0 ? _b : (_c = option) === null || _c === void 0 ? void 0 : _c.children) !== null && _d !== void 0 ? _d : "";
    let optValueAsString;
    if (typeof optValue === "string") {
        optValueAsString = optValue;
    }
    else {
        optValueAsString = (0, exports.getOptionStringContent)(optValue);
    }
    const normalize = (value) => value
        .toLowerCase()
        .normalize("NFKD")
        .replace(/\p{Diacritic}/gu, "");
    return normalize(optValueAsString).indexOf(normalize(input)) >= 0;
};
exports.defaultFilterOption = defaultFilterOption;
const withStaticProps = (forwarded, staticProps) => Object.assign(forwarded, staticProps);
exports.withStaticProps = withStaticProps;
exports.a11ySelectRules = {
    a11y: {
        config: {
            rules: [
                {
                    // Caused by Antd Select component's input `aria-expanded` attribute being missing on first render. It is correctly
                    // added when the options dropdown is first opened
                    id: "aria-required-attr",
                    selector: `*:not(input[role="combobox"])`,
                },
                {
                    // Caused by Antd Select component's input attributes `aria-owns`, `aria-controls`, `aria-activedescendant` referring to
                    // non-existing elements on first render which are correctly added when the options dropdown is first opened
                    id: "aria-valid-attr-value",
                    selector: `*:not(input[role="combobox"])`,
                },
                {
                    id: "label",
                    enabled: false,
                },
            ],
        },
    },
};
//# sourceMappingURL=helpers.js.map